import React from "react";
import { Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";

const PathComponent = ({ pageHeading, paths }) => {
  let navigate = useNavigate();

  return (
    <Grid item className={`sp-wrap2`}>
      <div className="flex items-center">
        <Grid item className="flex items-center">
          <div>
            <span
              className="main-path-text"
              onClick={() => navigate("/dashboard")}
            >
              {"Home"}
            </span>
            {paths?.length ? <span className="mx-1">{"/"}</span> : null}
          </div>
        </Grid>
        {paths?.length ? (
          <Grid item className="flex items-center">
            {paths?.reduce((acc, item) => {
              if (!acc.some(p => p?.label === item?.label)) {
                acc.push(item);
              }
              return acc;
            }, [])?.map((item, index) => (
              <div key={index}>
                <span
                  className={`main-path-text ${index === paths?.length - 1 ? 'main-path-text-active' : ''}`}
                  onClick={() => { 
                    if (item?.navigation) { navigate(`/${item?.navigation}`) } 
                    if (item?.onClick) { item?.onClick() } 
                  }}
                >
                  {item?.label}
                </span>
                <span className="mx-1">{index !== paths?.length - 1 && "/"}</span>
              </div>
            ))}
          </Grid>
        ) : null}
      </div>
      {/* <Grid item>
        <div className="main-path-heading">
          <GridViewIcon className="sp-icon" />
          <span className="main-path-heading-text mb-1">{pageHeading}</span>
        </div>
      </Grid> */}
      {/* <Grid item>
            <Typography variant="subtitle2" className="sp-text">
              Monitor any changes made to your project, schema, and
              content with audit logs.
              <Link
                to="#"
                className="sp-redirect"
                target="_blank"
              >
                Learn more
              </Link>
            </Typography>
          </Grid> */}
    </Grid>
  );
};

export default PathComponent;
